import { apiRequest } from '@/lib/api-client';
import {
  assertAnalyticsResponseScope,
  normalizeAnalyticsAddress
} from '@/lib/investor-analytics';
import {
  investorHoldingsQuerySchema,
  investorHoldingsResponseSchema,
  type InvestorHoldingsQuery,
  type InvestorHoldingsResponse
} from '../types/api';

export async function fetchInvestorHoldings(
  address: string,
  chainId: number,
  params: InvestorHoldingsQuery = {},
  signal?: AbortSignal
): Promise<InvestorHoldingsResponse> {
  const investor = normalizeAnalyticsAddress(address);
  const query = investorHoldingsQuerySchema.parse(params);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/holdings`,
    investorHoldingsResponseSchema,
    {
      auth: 'required',
      chainId,
      query,
      signal
    }
  );

  assertAnalyticsResponseScope(investor, chainId, response);
  return response;
}
